import { useEffect } from "react";
import Lenis from "lenis";
import { Nav } from "../components/landing/Nav";
import { Hero } from "../components/landing/Hero";
import { Marquee } from "../components/landing/Marquee";
import { Screens } from "../components/landing/Screens";
import { Features } from "../components/landing/Features";
import { Leaks } from "../components/landing/Leaks";
import { Updates } from "../components/landing/Updates";
import { Ideas } from "../components/landing/Ideas";
import { CTA, Footer } from "../components/landing/CTA";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true, anchors: { offset: -90 } });
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
    };
  }, []);

  return (
    <main className="grain relative bg-[#050911] text-white">
      <Nav />
      <Hero />
      <Marquee />
      <Screens />
      <Features />
      <Leaks />
      <Ideas />
      <Updates />
      <CTA />
      <Footer />
    </main>
  );
}
